import { isValidRSAA } from 'redux-api-middleware';
import _ from 'lodash'

/**
 * Control api fetching
 * Only allow fetching using redux-api-middleware if there is either no loading or fetched data
 * Action object: {
 *  meta: {
 *    controlledFetch: true,  / / Use middleware
 *    dataStatePath: '...',     // path used to access relevant data
 *    loadingStatePath: '...',  // path used to access relevant loading state
 *  }
 * }
 */
const controlledFetchMiddleware = store => next => action => {
  try {
    let passed = true;
    if (isValidRSAA(action)) {
      const actionObject = Object.values(action)[0];
      const { types } = actionObject;
      const requestActionConfig = types[0];
      const { meta = {} } = requestActionConfig;
      const { controlledFetch = false, dataStatePath, loadingStatePath } = meta;
      if (controlledFetch) {
        const state = store.getState();
        const noData = _.isEmpty(_.get(state, dataStatePath));
        const isLoading = _.get(state, loadingStatePath);
        if (isLoading || !noData) passed = false;
      }
    }
    if (passed) return next(action);
  } catch (error) {
    console.log('Caught an exception!', error);
    throw error;
  }
};

export default controlledFetchMiddleware;
